import {AnswerSource} from "../../../redux/survey/survey.types";
import {ReactElement, useRef, useState} from "react";
import aiStar from "../../../assets/icons-redesign/ai-star.svg";
import humanGroup from "../../../assets/icons-redesign/human-group.svg";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../components/ui/tooltip";

export interface AnswerSourceSliderProps {
  readonly initialFilter: AnswerSource;
  readonly onChange: (source: AnswerSource) => void;
}

const AnswerSourceSlider = ({ initialFilter, onChange }: AnswerSourceSliderProps): ReactElement => {
  const [sliderValue, setSliderValue] = useState(initialFilter);
  const thumbRef = useRef<HTMLDivElement | null>(null);

  useGSAP(() => {
    let color = '#3358fc';
    let left = '0px';
    switch (sliderValue) {
      case 1:
        color = 'rgba(117, 35, 241, 1)';
        left = 'calc(50% - 16px)';
        break;
      case 2:
        color = 'rgba(255, 109, 45, 1)';
        left = 'calc(100% - 32px)';
        break;
      default:
        color = '#3358fc';
        break;
    }

    gsap.to(thumbRef.current, {
      backgroundColor: color,
      left: left,
      duration: 0.25,
    });
  }, [sliderValue]);

  const onClick = (value: number) => {
    onChange(value as AnswerSource);
    setSliderValue(value);
  };
  const renderSlider = () => {
    return (
      <div className={'relative flex w-full touch-none select-none items-center'}>
        <div
          ref={thumbRef}
          className="absolute block w-8 h-8 rounded-full shadow bg-blue-light-500 transition-colors ease-in-out focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
        />
        <div className="relative h-10 w-full grow overflow-hidden rounded-full">
          <div className="absolute h-full w-full">
            <div className="flex flex-row justify-between items-center h-full w-full text-xs">
              <div
                className="flex h-8 w-8 items-center justify-center text-white"
                onClick={() => onClick(0)}
              >
                All
              </div>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div
                      className="flex h-8 w-8 items-center justify-center"
                      onClick={() => onClick(1)}
                    >
                      <img
                        src={aiStar}
                        style={{ filter: 'invert(1)' }}
                      />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    {"AI Panelist"}
                  </TooltipContent>
                </Tooltip>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div
                      className="flex h-8 w-8 items-center justify-center"
                      onClick={() => onClick(2)}
                    >
                      <img src={humanGroup} />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    {"Human"}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-row w-[118px] px-1 items-center bg-white/20 rounded-full">
      {renderSlider()}
    </div>
  );
};

export default AnswerSourceSlider;
